import { AxiosError } from 'axios';
import { getRequestUrl } from './getRequestUrl';

export class ApiCancelledError extends Error {
  readonly code: string;
  readonly url?: string;

  constructor(error: AxiosError) {
    super(error.message);

    this.name = error.name;
    this.code = error.code ?? AxiosError.ERR_CANCELED;
    this.url = getRequestUrl(error);
  }
}
